@if ((loadingService.isLoading$ | async)) {
    <app-main-loading/>
}

@if (oidc.isAuthenticated() | async) {
  @let notifications = appNotificationsService.notifications | async;
  @let showNotifications = notificationsPanelService.openNotifications$ | async;
  <div class="notifications-overlay" [ngClass]="{ 'open': showNotifications }"></div>

  <div class="notifications-wrapper" [ngClass]="{ 'open': showNotifications }">
    @if (showNotifications && notifications?.length) {
      <app-notifications-panel [notifications]="notifications"/>
    }
  </div>
}

<router-outlet/>
